import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { fetchSelectedFilters } from '../api'
import { personalizationKeys } from '../queryKeys'

const useGetSelectedFiltersQuery = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const query = useQuery(
    personalizationKeys.selectedFilters,
    () => fetchSelectedFilters(accountId),
    {
      onError: () => {
        errorToast('Something went wrong. Please try again.')
      },
    }
  )

  return query
}

export default useGetSelectedFiltersQuery
